<div class="dx-card" id="accordion">
  <dx-accordion
    #accordion
    [dataSource]="[{ title: 'Book Paper', item: {} }]"
    [collapsible]="true"
    [animationDuration]="300"
    [focusStateEnabled]="false"
    [hoverStateEnabled]="false"
    [selectedIndex]="-1"
    [deferRendering]="false"
    (onSelectionChanged)="onAccordionClick($event)"
  >
    <div *dxTemplate="let itemData of 'title'">
      <h3 style="padding-left: 0.3em">Book Paper</h3>
    </div>
    <div *dxTemplate="let itemData of 'item'">
      <dx-form #paperForm labelMode="floating">
        <dxi-item
          itemType="group"
          [colCount]="6"
          [colCountByScreen]="{ xs: 1 }"
        >
          <!-- Line 1 -->
          <dxi-item name="bookPaper" [colSpan]="3">
            <div *dxTemplate="let data">
              <dx-select-box
                stylingMode="filled"
                [dataSource]="paperTypeFieldItems"
                label="Paper Type"
                displayExpr="displayValue"
                valueExpr="keyValue"
                [searchEnabled]="false"
                style="caret-color: transparent"
                [value]="selectedPaperType?.keyValue"
                (onValueChanged)="paperTypeChanged($event)"
              ></dx-select-box>
            </div>
          </dxi-item>
          <dxi-item name="bookPaperColor" [colSpan]="3">
            <div *dxTemplate="let data">
              <dx-select-box
                stylingMode="filled"
                [dataSource]="bookPaperColorFieldItems"
                label="Color"
                displayExpr="displayValue"
                valueExpr="keyValue"
                [searchEnabled]="false"
                style="caret-color: transparent"
                [value]="selectedBookPaperColor?.keyValue"
                (onValueChanged)="bookPaperColorChanged($event)"
              ></dx-select-box>
            </div>
          </dxi-item>

          <!-- Line 2 -->
          <dxi-item name="bookPaperBleeds" [colSpan]="3">
            <div *dxTemplate="let data">
              <dx-select-box
                stylingMode="filled"
                [dataSource]="paperBleedsFieldItems"
                label="Bleeds"
                displayExpr="displayValue"
                valueExpr="keyValue"
                [searchEnabled]="false"
                style="caret-color: transparent"
                [value]="selectedPaperBleeds?.keyValue"
                (onValueChanged)="paperBleedsChanged($event)"
              ></dx-select-box>
            </div>
          </dxi-item>

          <dxi-item name="endsheet" [colSpan]="3">
            <div *dxTemplate="let data">
              <app-option-mapping-select-box
                #endsheetSelectBox
                [publisherId]="selectedPublisherId"
                [classification]="selectedClassification"
                subcategory="BOOK_PAPER"
                inputName="ENDSHEET"
                [summaryField]="{
                  name: 'endsheet',
                  category: 'Paper Specification',
                  label: 'Endsheet - non printed'
                }"
                (onValueChanged)="paperEndsheetChanged($event)"
                (summaryUpdate)="setEndsheetSummaryItems($event)"
              ></app-option-mapping-select-box>
            </div>
          </dxi-item>
        </dxi-item>
      </dx-form>
    </div>
  </dx-accordion>
</div>
